"use strict";
// 2eab2f8f-839f-43b6-ae5d-55079259ffc6
// export const siteIdLocal = '2370fe0b-c970-408f-a345-83e80675e87c';
// export const siteIdLocal = 'c0742951-3208-43e0-8e2e-040db47a424f'; // siteId prod
// export const siteIdLocal = '9acd3c09-af48-44e7-aa42-6a728a55e41d';
export const siteIdLocal = "3f6e9d67-9e5d-4614-8a72-4b20d2e539f0";
// export const siteIdLocal = 'e543537d-467c-4175-85db-15a3c16e8bec'; // testdevf
// export const siteIdLocal = '4a2312a0-f928-4b59-91ed-d5073cec3285';

// export const siteIdLocal = "f88fd92a-d7b2-460b-b32e-f3a715c6e9f8"; // sitecreatortest.com
// export const siteIdLocal = '13ae6568-28ac-480b-8337-a657d4487495';
